import React, { useContext, useState, useRef } from 'react';

import PlotDesigner from "../../../../framework/freesia-design-predatascreen/components/PlotDesigner";
import AddonActionDefault from "../../../../framework/freesia-design-predatascreen/components/PlotDesigner/addons/AddonActionDefault";
import AddonActionDrawRectangle from "../../../../framework/freesia-design-predatascreen/components/PlotDesigner/addons/AddonActionDrawRectangle";
import AddonActionDrawEllipse from "../../../../framework/freesia-design-predatascreen/components/PlotDesigner/addons/AddonActionDrawEllipse";
import AddonActionDrawText from "../../../../framework/freesia-design-predatascreen/components/PlotDesigner/addons/AddonActionDrawText";
import AddonActionDrawPage from "../../../../framework/freesia-design-predatascreen/components/PlotDesigner/addons/AddonActionDrawPage";
import AddonViewAll from "../../../../framework/freesia-design-predatascreen/components/PlotDesigner/addons/AddonViewAll";
import AddonView100p from "../../../../framework/freesia-design-predatascreen/components/PlotDesigner/addons/AddonView100p";
import AddonExportDropdown from "../../../../framework/freesia-design-predatascreen/components/PlotDesigner/addons/AddonExportDropdown";
import AddonExportToImage from "../../../../framework/freesia-design-predatascreen/components/PlotDesigner/addons/AddonExportToImage";
import AddonExportToJsonFile from "../../../../framework/freesia-design-predatascreen/components/PlotDesigner/addons/AddonExportToJsonFile";
import AddonSelectionProperties from "../../../../framework/freesia-design-predatascreen/components/PlotDesigner/addons/AddonSelectionProperties";

import "./index.less";

const PlotDesignerPage = function (props) {

    return <>
        <div className="h100 w100 layout-h" style={{ backgroundColor: "rgb(236, 236, 236)" }}>
            <PlotDesigner className="fill" addons={[
                {
                    location: "top-right",
                    Component: AddonActionDefault,
                    group: "action",
                },
                {
                    location: "top-right",
                    Component: AddonActionDrawRectangle,
                    group: "action",
                    divider: true,
                },
                {
                    location: "top-right",
                    Component: AddonActionDrawEllipse,
                    group: "action",
                },
                {
                    location: "top-right",
                    Component: AddonActionDrawText,
                    group: "action",
                },
                {
                    location: "top-right",
                    Component: AddonActionDrawPage,
                    group: "action",
                },
                {
                    location: "top-right",
                    Component: AddonView100p,
                    group: "view",
                },
                {
                    location: "top-right",
                    Component: AddonViewAll,
                    group: "view",
                },
                {
                    location: "top-right",
                    Component: AddonExportDropdown,
                    group: "export",
                    type: "dropdown",
                    name: "export-dropdown-menu",
                },
                {
                    location: "top-right",
                    Component: AddonExportToImage,
                    group: "export",
                    target: "export-dropdown-menu"
                },
                {
                    location: "top-right",
                    Component: AddonExportToJsonFile,
                    group: "export",
                    target: "export-dropdown-menu"
                },
                {
                    name: "AddonSelectionProperties",
                    alias: "属性",
                    location: "sider-right",
                    Component: AddonSelectionProperties,
                    svgIcon: "details"
                }
            ]} />
        </div>
    </>
}

export default PlotDesignerPage;